import moment from 'moment'
import image1 from '../assets/ASPOM Employee handbook V11_page-0001.jpg'
import image2 from '../assets/ASPOM Employee handbook V11_page-0002.jpg'
import image3 from '../assets/ASPOM Employee handbook V11_page-0003.jpg'
import image4 from '../assets/ASPOM Employee handbook V11_page-0004.jpg'
import image5 from '../assets/ASPOM Employee handbook V11_page-0005.jpg'
import image6 from '../assets/ASPOM Employee handbook V11_page-0006.jpg'
import image7 from '../assets/ASPOM Employee handbook V11_page-0007.jpg'
import image8 from '../assets/ASPOM Employee handbook V11_page-0008.jpg'
import image9 from '../assets/ASPOM Employee handbook V11_page-0009.jpg'
import image10 from '../assets/ASPOM Employee handbook V11_page-0010.jpg'
import image11  from '../assets/ASPOM Employee handbook V11_page-0011.jpg'
import image12 from '../assets/ASPOM Employee handbook V11_page-0012.jpg'
import image13 from '../assets/ASPOM Employee handbook V11_page-0013.jpg'
import image14 from '../assets/ASPOM Employee handbook V11_page-0014.jpg'
import image15 from '../assets/ASPOM Employee handbook V11_page-0015.jpg'
import image16 from '../assets/ASPOM Employee handbook V11_page-0016.jpg'
import image17 from '../assets/ASPOM Employee handbook V11_page-0017.jpg'
import image18 from '../assets/ASPOM Employee handbook V11_page-0018.jpg'
import image19 from '../assets/ASPOM Employee handbook V11_page-0019.jpg'
import image20 from '../assets/ASPOM Employee handbook V11_page-0020.jpg'
import image21 from '../assets/ASPOM Employee handbook V11_page-0021.jpg'
import image22 from '../assets/ASPOM Employee handbook V11_page-0022.jpg'
import image23 from '../assets/ASPOM Employee handbook V11_page-0023.jpg'
import image24 from '../assets/ASPOM Employee handbook V11_page-0024.jpg'
import image25 from '../assets/ASPOM Employee handbook V11_page-0025.jpg'
import image26 from '../assets/ASPOM Employee handbook V11_page-0026.jpg'
import image27 from '../assets/ASPOM Employee handbook V11_page-0027.jpg'
import image28 from '../assets/ASPOM Employee handbook V11_page-0028.jpg'
import image29 from '../assets/ASPOM Employee handbook V11_page-0029.jpg'
import image30 from '../assets/ASPOM Employee handbook V11_page-0030.jpg'
import image31 from '../assets/ASPOM Employee handbook V11_page-0031.jpg'
import image32 from '../assets/ASPOM Employee handbook V11_page-0032.jpg'
import image33 from '../assets/ASPOM Employee handbook V11_page-0033.jpg'
import image34 from '../assets/ASPOM Employee handbook V11_page-0034.jpg'
import image35 from '../assets/ASPOM Employee handbook V11_page-0035.jpg'
import image36 from '../assets/ASPOM Employee handbook V11_page-0036.jpg'


export const filterDate = (arrayBox, option) => {
    const currentDate = new Date()
    switch (option) {
        case '':
            return arrayBox?.filter((item)=> item.date === currentDate.toISOString().slice(0, 10))
        case 'Today':
            return arrayBox?.filter((item)=> item.date === currentDate.toISOString().slice(0, 10))
        case 'Week':
            const weekStartDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - currentDate.getDay()) 
            const weekEndDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - currentDate.getDay() + 6)
            return arrayBox.filter((item)=> new Date(item.date) >= weekStartDate && new Date(item.date) <= weekEndDate)
        case 'January':
            const januaryStartDate = new Date(currentDate.getFullYear(), 0, 1);
            const januaryEndDate = new Date(currentDate.getFullYear(), 0, 31);
            return arrayBox.filter(item => new Date(item.date) >= januaryStartDate && new Date(item.date) <= januaryEndDate);
        case 'February':
            const februaryStartDate = new Date(currentDate.getFullYear(), 1, 1);
            const februaryEndDate = new Date(currentDate.getFullYear(), 1, 28); // Assuming February has 28 days
            return arrayBox.filter(item => new Date(item.date) >= februaryStartDate && new Date(item.date) <= februaryEndDate);
        case 'March':
            const marchStartDate = new Date(currentDate.getFullYear(), 2, 1);
            const marchEndDate = new Date(currentDate.getFullYear(), 2, 31);
            return arrayBox.filter(item => new Date(item.date) >= marchStartDate && new Date(item.date) <= marchEndDate);
        case 'April':
            const aprilStartDate = new Date(currentDate.getFullYear(), 3, 1);
            const aprilEndDate = new Date(currentDate.getFullYear(), 3, 30);
            return arrayBox.filter(item => new Date(item.date) >= aprilStartDate && new Date(item.date) <= aprilEndDate);
        case 'May':
            const mayStartDate = new Date(currentDate.getFullYear(), 4, 1);
            const mayEndDate = new Date(currentDate.getFullYear(), 4, 31);
            return arrayBox.filter(item => new Date(item.date) >= mayStartDate && new Date(item.date) <= mayEndDate);
        case 'June':
            const juneStartDate = new Date(currentDate.getFullYear(), 5, 1);
            const juneEndDate = new Date(currentDate.getFullYear(), 5, 30);
            return arrayBox.filter(item => new Date(item.date) >= juneStartDate && new Date(item.date) <= juneEndDate);
        case 'July':
            const julyStartDate = new Date(currentDate.getFullYear(), 6, 1);
            const julyEndDate = new Date(currentDate.getFullYear(), 6, 31);
            return arrayBox.filter(item => new Date(item.date) >= julyStartDate && new Date(item.date) <= julyEndDate);
        case 'August':
            const augustStartDate = new Date(currentDate.getFullYear(), 7, 1);
            const augustEndDate = new Date(currentDate.getFullYear(), 7, 31);
            return arrayBox.filter(item => new Date(item.date) >= augustStartDate && new Date(item.date) <= augustEndDate);
        case 'September':
            const septemberStartDate = new Date(currentDate.getFullYear(), 8, 1);
            const septemberEndDate = new Date(currentDate.getFullYear(), 8, 30);
            return arrayBox.filter(item => new Date(item.date) >= septemberStartDate && new Date(item.date) <= septemberEndDate);
        case 'October':
            const octoberStartDate = new Date(currentDate.getFullYear(), 9, 1);
            const octoberEndDate = new Date(currentDate.getFullYear(), 9, 31);
            return arrayBox.filter(item => new Date(item.date) >= octoberStartDate && new Date(item.date) <= octoberEndDate);
        case 'November':
            const novemberStartDate = new Date(currentDate.getFullYear(), 10, 1);
            const novemberEndDate = new Date(currentDate.getFullYear(), 10, 30);
            return arrayBox.filter(item => new Date(item.date) >= novemberStartDate && new Date(item.date) <= novemberEndDate);
        case 'December':
            const decemberStartDate = new Date(currentDate.getFullYear(), 11, 1);
            const decemberEndDate = new Date(currentDate.getFullYear(), 11, 31);
            return arrayBox.filter(item => new Date(item.date) >= decemberStartDate && new Date(item.date) <= decemberEndDate);
        default:
            return arrayBox
        }
}

export const filterAccount = (arrayBox, option) => {
    const currentDate = new Date();
    switch (option) {
        case '':
        case 'Today':
            return arrayBox.filter(user => {
                // Check if any of the user's tasks were submitted today
                return user.tasks.some(task => {
                    const taskDate = new Date(task.date);
                    return taskDate.toDateString() === currentDate.toDateString();
                });
            });
        case 'Week':
            const weekStartDate = new Date(currentDate);
            weekStartDate.setDate(currentDate.getDate() - currentDate.getDay());
            const weekEndDate = new Date(weekStartDate);
            weekEndDate.setDate(weekStartDate.getDate() + 6);
            return arrayBox.filter(item =>
                item.tasks?.some(
                    itemDate => {
                        const taskDate = new Date(itemDate.date);
                        return taskDate >= weekStartDate && taskDate <= weekEndDate;
                    }
                )
            );
        default:
            const monthIndex = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].indexOf(option);
            if (monthIndex !== -1) {
                const monthStartDate = new Date(currentDate.getFullYear(), monthIndex, 1);
                const monthEndDate = new Date(currentDate.getFullYear(), monthIndex + 1, 0);
                return arrayBox.filter(item =>
                    item.tasks?.some(
                        itemDate => {
                            const taskDate = new Date(itemDate.date);
                            return taskDate >= monthStartDate && taskDate <= monthEndDate;
                        }
                    )
                );
            } else {
                return arrayBox;
            }
    }
};

export const appraisalTableData = [
    {
        id: 1,
        keyResultArea: 'Quality',
        keyPerformanceIndicators: [
            'Work is accurate and precise.',
            'Error-free rating.	',
            'Displays thoroughness and completeness in work activity.',
            'Takes proper care of equipment/keeps work area clean.',
        ]
    },
    {
        id: 2,
        keyResultArea: 'Productivity',
        keyPerformanceIndicators: [
            'Meeting set targets.',	
            'Time utilization.',	
            'Commitment to performing responsibilities',
            'Problem solving.',	
            'Judgement and decision making.',
            'Adaptability'
        ]
    },
    {
        id: 3,
        keyResultArea: 'Job knowledge',
        keyPerformanceIndicators: [
            'Able to follow verbal and/or written instructions.',
            'Uses proper procedures.',
            'Uses proper methods and tools.',
            'Performs work without detailed instructions.',	
            'Shows improvement on repetitive tasks.',
            'Able to train others (if applicable).',	
            'Has practical/technical knowledge to perform job.'
        ]
    },
    {
        id: 4,
        keyResultArea: 'Reliability',
        keyPerformanceIndicators: [
            'Begins and finishes on time.',	
            'Requires minimum supervision; completes tasks without prompting.',	
            'Completes tasks efficiently within required time frames.',
            'Puts in extra time and effort.',	
            'Does the best according to ability and within minimum job standards.',
        ]
    },
    {
        id: 5,
        keyResultArea: 'Attendance',
        keyPerformanceIndicators: [
            'At work on a daily basis.',
            'Start and finishes according to approved schedule (punctual).',	
            'Calls/Emails to explain absence.',	
            'Observes generally agreed work break/meal periods.',	
            'Availability/Punctuality to meetings and other Job related engagements.',
        ]
    },
    {
        id: 6,
        keyResultArea: 'Initiative/Creativity',
        keyPerformanceIndicators: [
            'Seeks out new assignments when finished with own work.',
            'Assumes additional responsibilities when needed.',
            'Properly selects priorities.',	
            'Determines what must be done without being told.',	
            'Makes suggestions on better ways of getting work done.',
            'Identifies and corrects errors during the work process.',
        ]
    },
    {
        id: 7,
        keyResultArea: 'Teamwork',
        keyPerformanceIndicators: [
            'Works well with supervisors, peers, and subordinates.',	
            'Sets an example with a positive and supportive attitude',	
            'Communicates well with co-workers and supervisors.',
            'Promotes teamwork in the work place.',
        ]
    },
    {
        id: 8,
        keyResultArea: 'Policy Compliance',
        keyPerformanceIndicators: [
            'Practices proper safety procedures.',
            'Adheres to all company policies and regulations.',	
            'Taking to correction.',
        ]
    },
    {
        id: 9,
        keyResultArea: 'Customer Service',
        keyPerformanceIndicators: [
            'Establishes positive relations colleagues and customers.',
            'Responsive and courteous to client inquiries.',	
            'Relationship with Clients from pre-sale to after sale',
        ]
    },
    {
        id: 10,
        keyResultArea: 'Communication Skills',
        keyPerformanceIndicators: [
            'Active Listening',	
            'Clarifying and Summarizing.',	
            'Being Clear and Succinct',	
            'Providing Feedback.',	
            'Developing trust and rapport.',
            'Being Empathetic.',
        ]
    },
]

export const handBookArray = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
    image20,
    image21,
    image22,
    image23,
    image24,
    image25,
    image26,
    image27,
    image28,
    image29,
    image30,
    image31,
    image32,
    image33,
    image34,
    image35,
    image36,
]


export const getAttendanceStats = (attendance) => {
    // Get the current month and year
    const currentDate = new Date();
    const currentMonth = currentDate.toLocaleString('en-US', { month: 'long' });
    const currentYear = currentDate.getFullYear();
  
    // Initialize variables to store counts
    let presentCount = 0;
    let absentCount = 0;
    let lateCount = 0;
    let totalHoursToday = 0;
    let totalHoursThisWeek = 0;
    let totalHoursThisMonth = 0;
    // Get today's date
    const today = parseInt(moment().format('D'), 10);
  
    // Iterate over the attendance array
    attendance.forEach((entry) => {
        // Check if the entry falls within the current month and year
        if (entry.month === currentMonth && entry.year === String(currentYear)) {
            presentCount += entry.totalMarkedDays;
            entry.days.forEach((day) => {
                if (day.status === 'Absent') {
                    absentCount++;
                } else if (day.status === 'Late') {
                    lateCount++;
                }

                // Check if the day is today and not absent, and clockIn and clockOut are available
                if (day.day === today && day.status !== 'Absent' && day.clockIn) {
                    // Calculate the duration between clockIn and clockOut for today
                    const durationToday = moment(day.clockOut ? day.clockOut : new Date()).diff(moment(day.clockIn), 'hours', true);
                    // Add the duration to total hours for today
                    totalHoursToday += durationToday;
                }

                // Check if the day falls within the current week and not absent, and clockIn and clockOut are available
                if (moment(day.clockIn).isSame(currentDate, 'week') && day.status !== 'Absent' && day.clockIn && day.clockOut) {
                    // Calculate the duration between clockIn and clockOut for this week
                    const durationThisWeek = moment(day.clockOut).diff(moment(day.clockIn), 'hours', true);
                    // Add the duration to total hours for this week
                    totalHoursThisWeek += durationThisWeek;
                }

                // Check if the day falls within the current month and not absent, and clockIn and clockOut are available
                if (moment(day.clockIn).format('MMMM') === currentMonth && day.status !== 'Absent' && day.clockIn && day.clockOut) {
                    // Calculate the duration between clockIn and clockOut for this month
                    const durationThisMonth = moment(day.clockOut).diff(moment(day.clockIn), 'hours', true);
                    // Add the duration to total hours for this month
                    totalHoursThisMonth += durationThisMonth;
                }
            });
        }
    });
  
    // Calculate total hours this week and this month similarly
  
    return {
        presentCount,
        absentCount,
        lateCount,
        hoursSpent: [totalHoursToday.toFixed(2), totalHoursThisWeek.toFixed(2), totalHoursThisMonth.toFixed(2)]
        // Add total hours this week and this month
    };
};


export const getAttendanceTableStats = (attendance) =>{
    const reducedAttendance = attendance.reduce((acc, entry) => {
        const dayData = entry.days.map((d)=>{
            const id = d?._id
            const createdAt = moment(d?.clockIn).format('YYYY-MM-DD');
            const clockIn = moment(d?.clockIn).format('HH:mm:ss A') || null;
            const clockOut = d?.clockOut ? moment(d?.clockOut).format('HH:mm:ss A') : '';
            const status = d?.status || null;
        
            // Calculate hoursSpent if both clockIn and clockOut are available
            let hoursSpent = null;
            if (clockIn && clockOut && status !== 'Absent') {
                const duration = moment(d?.clockOut).diff(moment(d?.clockIn), 'hours', true);
                hoursSpent = duration.toFixed(2);
            }else{
                hoursSpent = ''
            }
        
            return { id, createdAt, clockIn, clockOut, status, hoursSpent };

        })
        return [...acc, ...dayData]
    }, []);

    reducedAttendance.sort((a, b)=>{
        return moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf()
    })

    return reducedAttendance
}